/**
 * @see https://bipalgroup.larksuite.com/sheets/WrFNsj597hFP96tKB5Pu3RWnsvg
 */

import { useMemo } from "react";
import { ActionType } from "~/pages/constants";
import { CHAIN_IDS } from "~/Provider/ConnectionWrapper";

export const SuggestionAmountsMap: {
    [chainId: string]: { [tokenSymbol: string]: [number, number, number] };
} = {
    [String(CHAIN_IDS.SOLANA)]: {
        ["SOL"]: [0.1, 1, 2],
        ["USDC"]: [100, 200, 500],
    },
    [String(CHAIN_IDS.ETH)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.BASE)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
        ["USDBC"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.BNBCHAIN)]: {
        ["BNB"]: [0.2, 1, 5],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
        ["DAI"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.MERLIN)]: {
        ["BTC"]: [0.001, 0.01, 0.1],
        ["MERL"]: [100, 1000, 10000],
        ["M-USDT"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.POLYGON)]: {
        ["POL"]: [100, 1000, 10000],
        ["USDT"]: [100, 200, 500],
        ["USDC"]: [100, 200, 500],
    },
    [String(CHAIN_IDS.ARB)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
        ["DAI"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.OPTIMISM)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
        ["DAI"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.AVALANCHEC)]: {
        ["AVAX"]: [1, 10, 100],
        ["USDT"]: [50, 500, 3000],
        ["USDC"]: [50, 500, 3000],
    },
    [String(CHAIN_IDS.LINEA)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.CORE)]: {
        ["CORE"]: [30, 300, 3000],
        ["USDT"]: [30, 300, 3000],
        ["USDC"]: [30, 300, 3000],
    },
    [String(CHAIN_IDS.ZKLINK)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
    },
    [String(CHAIN_IDS.ZKSYNC)]: {
        ["ETH"]: [0.1, 0.5, 1],
        ["USDT"]: [200, 1000, 3000],
        ["USDC"]: [200, 1000, 3000],
    },
};

const DEFAULT_AMOUNTS = [1, 5, 20];

const useSuggestionAmounts = (
    chainId: string,
    tokenSymbol: string,
    tradeActionType: ActionType
) => {
    return useMemo(() => {
        if (tradeActionType === ActionType.Sell) {
            return [10, 50, 100];
        }

        const tokens = SuggestionAmountsMap[chainId];
        if (!tokens) return DEFAULT_AMOUNTS;

        const token = Object.keys(tokens).find((symbol) =>
            new RegExp(symbol, "i").test(tokenSymbol)
        );

        return token ? tokens[token] : DEFAULT_AMOUNTS;
    }, [chainId, tokenSymbol, tradeActionType]);
};

export default useSuggestionAmounts;
